import React, { useState} from 'react'
import {Grid, Input, Segment, Icon, Label, Form,List,Message} from "semantic-ui-react";
import Axios from "axios";
import moment from "moment";
import Constants from "../../../config/constants";
const options = [
    {key: 'm', text: 'ชาย', value: 'M'},
    {key: 'f', text: 'หญิง', value: 'F'}
]

const optionsBlood = [
    {key: 'a', text: 'A', value: 'A'},
    {key: 'b', text: 'B', value: 'B'},
    {key: 'ab', text: 'AB', value: 'AB'},
    {key: 'o', text: 'O', value: 'O'}
]
const Patient = () => {
    const [input, setInput] = useState({
        search: '',
        gender: '',
        surname : '',
        name: '',
        citizen_id: '',
        address: '',
        telephone:'',
        email : '',
        blood_group : '',
        rh : '',
        remark : '',
        id: '',
        hn:'',
        birth_date:'',
        tambol_id:'',
        amphur_id:'',
        province_id:'',
        zipcode:'',
        timestamp:'',
        created_date:'',
        name_error : false,
        surname_error : false,
        citizen_error : false,
        error : false
    });




    const [users, setUsers] = useState([]);
    const [user, setUser] = useState({});

    const handleValueChange = (e) => {
        const {
            name, value
        } = e.target;
        console.log(name, value, e)
        setInput((prevInput) => ({
            ...prevInput,
            [name]: value,
        }))
    };

    const search = async (e) => {
        try {
            const {
                name, value
            } = e.target;
            setInput((prevInput) => ({
                ...prevInput,
                [name]: value,
            }))

            let res = await Axios.get('http://'+Constants.url+':'+Constants.port+'/v1/snr/patient?search='+input.search);
            setUsers(res.data.data);
        } catch (e) {
            console.log(e);
        }
    }

    const resetSate =  ()=>{
        setInput((prevInput) => ({
            ...prevInput,
            search: '',
            gender: '',
            surname : '',
            name: '',
            citizen_id: '',
            address: '',
            telephone:'',
            email : '',
            blood_group : '',
            rh : '',
            remark : '',
            id: '',
            hn:'',
            birth_date:'',
            tambol_id:'',
            amphur_id:'',
            province_id:'',
            zipcode:'',
            timestamp:'',
            created_date:''
        }))
    }

    const validatePatient = () =>{
        if(input.name == ''){
            input.error = true
            input.name_error = '- ชื่อต้องไม่ว่าง \n'
        }
        if(input.surname == ''){
            input.error = true
            input.surname_error = '- นามสกุลต้องไม่ว่าง \n'
        }
        if(input.citizen_id == ''){
            input.error = true
            input.citizen_error = '- เลขบัตรประชาชนต้องไม่ว่าง \n'
        }


    }

    const savePatient = async () => {
        try {
            validatePatient()
            if(input.error == false) {
                let result = await Axios.post('http://' + Constants.url + ':' + Constants.port + '/v1/snr/patient',

                    {
                        name: input.name,
                        surname: input.surname,
                        address: input.address,
                        citizen_id: input.citizen_id,
                        gender: input.gender,
                        telephone: input.telephone,
                        email: input.email,
                        blood_group: input.blood_group,
                        rh: input.rh,
                        remark: input.remark,
                        hn: input.hn,
                        id: input.id
                    }
                );
                alert(result.data.data.message)
                resetSate()
            }
        } catch (e) {
            console.log(e)
        }
    }

    const getUserById = async (user) => {
        try {
            let response = await Axios.get('http://'+Constants.url+':'+Constants.port+'/v1/snr/patient?id=' + user.id);
                response = response.data.data[0]
            console.log(response)
            setInput((prevInput) => ({
                ...prevInput,
                name: response.name,
                surname: response.surname,
                address: response.address,
                citizen_id: response.citizen_id,
                gender: response.gender,
                telephone:response.telephone,
                email : response.email,
                blood_group : response.blood_group,
                rh : response.rh,
                remark : response.remark,
                hn : response.hn,
                id : response.id
            }))

        } catch (e) {
            console.log(e);
        }
    }
    return (
        <div style={{display: "flex", minHeight: "90vh", flexDirection: "column"}}>

            <div style={{flex: 1}}>
                <Grid style={{marginTop: "5em", marginLeft: "2em"}}>
                    <Grid.Row>
                        <Grid.Column width={3}>
                            <Label>
                                <Icon name='user'/> ค้นหา HN , ชื่อ , บัตรประชาชน
                            </Label>
                            <Input
                                style={{display: 'flex'}}
                                name={"search"}
                                onChange={(e) => search(e)}
                                placeholder=' HN , ชื่อ , บัตรประชาชน'
                                value={input.search}
                                icon='search'
                            />

                            <List divided relaxed>
                                {
                                    users.map(user => (
                                    <List.Item>
                                        <List.Icon name='user circle icon' size='large' verticalAlign='middle' />
                                        <List.Content
                                            onClick={(e) => getUserById(user)}
                                            key={user.id}
                                        >
                                            <List.Header as='a'>{user.name}</List.Header>
                                            <List.Description as='a'>register date {moment(user.created_date).format("DD-MM-YYYY")}</List.Description>
                                        </List.Content>
                                    </List.Item>
                                    ))
                                }
                            </List>


                        </Grid.Column>
                        <Grid.Column width={12}>
                            <Segment>


                                <Form>
                                    <Form.Group widths='equal'>

                                        <Form.Input readOnly={'readOnly'} icon={'user'}  fluid label='HN' name='hn' value={input.hn}
                                                    placeholder='HN'/>
                                        <Form.Input required={'true'} fluid label='ชื่อ' name='name' value={input.name}
                                                    placeholder='ชื่อ'
                                                    onChange={(e)=>handleValueChange(e)}
                                                    error={input.name_error}

                                        />
                                        <Form.Input required={'true'} fluid label='นามสกุล' name='surname' value={input.surname}
                                                    placeholder='นามสกุล'   error={input.surname_error}  onChange={(e)=>handleValueChange(e)}
                                        />
                                        <Form.Select
                                            fluid
                                            label='เพศ'
                                            name='gender'
                                            value={input.gender}
                                            options={options}
                                            placeholder='Gender'
                                            onChange={(e, {name, value})=>handleValueChange({target:{name, value}})}

                                        />
                                        <Form.Input required={'true'} fluid label='เลขบัตรประชาชน' name='citizen_id' value={input.citizen_id}
                                                    placeholder='บัตรประชาชน' error={input.citizen_error}    onChange={(e)=>handleValueChange(e)}
                                                    />

                                    </Form.Group>
                                    <Form.Group widths='equal'>


                                        <Form.Input fluid label='เบอร์โทรศัพท์' name='telephone' value={input.telephone}
                                                    placeholder='เบอร์โทรศัพท์'  onChange={(e)=>handleValueChange(e)}/>
                                        <Form.Input fluid label='email' name='email' value={input.email}
                                                    placeholder='email'  onChange={(e)=>handleValueChange(e)}/>

                                        <Form.Select
                                            fluid
                                            label='หมู่เลือด'
                                            name='blood_group'
                                            value={input.blood_group}
                                            options={optionsBlood}
                                            placeholder='หมู่เลือด'
                                            onChange={(e, {name, value})=>handleValueChange({target:{name, value}})}
                                        />
                                        <Form.Input fluid label='RH' name='rh' value={input.rh}
                                                    placeholder='RH'  onChange={(e)=>handleValueChange(e)}/>
                                    </Form.Group>
                                    <Form.TextArea label='ที่อยู่ตามบัตรประชาชน'  placeholder='ที่อยู่ตามบัตรประชาชน' name='address'
                                                   value={input.address}  onChange={(e)=>handleValueChange(e)}/>
                                    <Form.TextArea label='หมายเหตุ'  placeholder='หมายเหตุ' name='remark'
                                                   value={input.remark}  onChange={(e)=>handleValueChange(e)}/>



                                    <Form.Button primary
                                                 onClick={() => savePatient()}
                                    >บันทึก</Form.Button>
                                </Form>

                            </Segment>


                        </Grid.Column>
                    </Grid.Row>

                </Grid>
            </div>

        </div>
    );
}

export default Patient;
